import { useContext } from 'react';
import { SandboxContext } from '../SandboxSessionProvider';

/**
 * Hook for consuming sandbox session state.
 * Must be used within a SandboxSessionProvider.
 */
export function useSandboxSession() {
  const ctx = useContext(SandboxContext);
  if (!ctx) {
    throw new Error('useSandboxSession must be used within SandboxSessionProvider');
  }
  return ctx;
}
